import localStorageConst from '@constants/localStorage';
import localStorage from '../localStorage';

export const getPermissionsFromStorage = () =>
  localStorage.getItem(localStorageConst.CLIENT_PERMISSIONS);

export const setPermissionsToStorage = permissions => {
  localStorage.setItem(localStorageConst.CLIENT_PERMISSIONS, permissions);
};
